import * as React from "react";
import { ToastBox } from "./styles";
export default class Toast extends React.PureComponent {
    render() {
        const { message, width, height } = this.props;
        return (React.createElement(ToastBox, { width: width, height: height }, message));
    }
}
